import React from "react";
import { S, openConsult } from "../site.js";
const { useState: useState_Prod, useEffect: useEffect_Prod, useRef: useRef_Prod } = React;

function SmartPostMockup({ compact, reviewSafe = false }) {
  const composer = (
    <div className="mockup" style={{ flex: compact ? 1 : 1.1, padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
      <div className="flex items-center gap-2">
        <span className="mono" style={{ fontSize: 10, color: "var(--fg-subtle)", letterSpacing: "0.08em" }}>COMPOSER</span>
        <span style={{ flex: 1 }} />
        <span className="tag tag-indigo" style={{ fontSize: 9 }}>{reviewSafe ? "AI · DRAFT" : "AI · Burmese"}</span>
      </div>
      <div style={{
        background: "rgba(20,24,30,0.04)", borderRadius: 8, padding: 10,
        fontSize: 12, color: "var(--fg-muted)", lineHeight: 1.5, minHeight: compact ? 56 : 80,
      }}>
        {reviewSafe
          ? "Campaign brief · Draft variations prepared for review before any external publishing."
          : "New season launch · 30% off · မိုးရာသီ ဈေးကြီး အရောင်းပွဲတော် ···"}
      </div>
      <div className="flex gap-2">
        {(reviewSafe ? ["Plan", "Draft", "Review"] : ["FB", "IG", "TikTok"]).map((tag) => (
          <span className="tag" key={tag}>{tag}</span>
        ))}
      </div>
      <div style={{ flex: 1 }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <span className="mono" style={{ fontSize: 10, color: "var(--fg-subtle)" }}>
          {reviewSafe ? "HUMAN APPROVAL REQUIRED" : "SCHEDULE · WED 7:30 PM"}
        </span>
        <span style={{
          background: "var(--ink)", color: "var(--on-ink)",
          padding: "4px 10px", borderRadius: 6, fontSize: 10, whiteSpace: "nowrap",
        }}>{reviewSafe ? "Prepared · Not published" : "Generate variants"}</span>
      </div>
    </div>
  );

  const calendar = reviewSafe ? (
    <div className="mockup" style={{ flex: 1, padding: 12 }}>
      <div className="flex items-center between" style={{ marginBottom: 12 }}>
        <span className="mono" style={{ fontSize: 10, color: "var(--fg-subtle)", letterSpacing: "0.08em" }}>REVIEW QUEUE</span>
        <span className="tag tag-indigo" style={{ fontSize: 9 }}>PILOT</span>
      </div>
      {["Plan complete", "Draft prepared", "Human review required"].map((label, index) => (
        <div key={label} className="flex items-center gap-3" style={{
          minHeight: 42, padding: "8px 0", borderBottom: index < 2 ? "1px solid var(--line-soft)" : "none",
        }}>
          <span aria-hidden="true" style={{
            width: 8, height: 8, borderRadius: 999, flexShrink: 0,
            background: index === 2 ? "var(--vermilion)" : "var(--indigo)",
          }} />
          <span style={{ fontSize: 11.5, color: "var(--fg-muted)" }}>{label}</span>
        </div>
      ))}
      <div style={{
        marginTop: 12, padding: "8px 10px", background: "rgba(20,24,30,0.04)",
        borderRadius: 6, fontSize: 10.5, color: "var(--fg-muted)",
      }}>Publishing remains held until a person approves it.</div>
    </div>
  ) : (
    <div className="mockup" style={{ flex: 1, padding: 12 }}>
      <div className="flex items-center between" style={{ marginBottom: 10 }}>
        <span className="mono" style={{ fontSize: 10, color: "var(--fg-subtle)", letterSpacing: "0.08em" }}>WEEK · MAY 12</span>
        <span className="mono" style={{ fontSize: 10, color: "var(--fg-subtle)" }}>›</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3, marginBottom: 8 }}>
        {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (
          <div key={i} style={{ textAlign: "center", fontSize: 9, color: "var(--fg-subtle)" }}>{d}</div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3 }}>
        {Array.from({ length: 21 }).map((_, i) => (
          <div key={i} style={{
            aspectRatio: "1/1", borderRadius: 4,
            background: [3, 4, 9, 14, 17].includes(i) ? "var(--indigo)" : "rgba(20,24,30,0.06)",
            opacity: [3, 4, 9, 14, 17].includes(i) ? 1 : 0.8,
          }} />
        ))}
      </div>
      <div style={{
        marginTop: 12, padding: "6px 8px", background: "rgba(20,24,30,0.04)",
        borderRadius: 6, fontSize: 10, color: "var(--fg-muted)",
      }}>⬤ 5 scheduled this week</div>
    </div>
  );

  return (
    <div style={{ position: "absolute", inset: 0, display: "flex", gap: 12, padding: "10px 0" }}>
      {composer}
      {!compact && calendar}
    </div>
  );
}

function TalentMockup({ compact, reviewSafe = false }) {
  const candidates = reviewSafe ? [
    { n: "Candidate record A", role: "Frontend engineering · Remote", status: "Ready for review" },
    { n: "Candidate record B", role: "Product delivery · Hybrid", status: "Context confirmed" },
    { n: "Candidate record C", role: "Quality coordination · Remote", status: "Needs discussion" },
  ] : [
    { n: "Candidate · TC-2401", role: "Frontend · 3 yrs · Remote", match: 94, status: "Shortlist" },
    { n: "Candidate · TC-1872", role: "Fullstack · 5 yrs · Singapore", match: 88, status: "Shortlist" },
    { n: "Candidate · TC-3019", role: "Frontend · 4 yrs · Bangkok", match: 81, status: "Reviewing" },
  ];
  const shown = compact ? candidates.slice(0, 2) : candidates;
  return (
    <div style={{
      position: "absolute", inset: 0,
      display: "flex", flexDirection: "column", gap: 10, padding: "10px 0",
    }}>
      <div className="mockup" style={{ padding: 12 }}>
        <div className="flex items-center between" style={{ marginBottom: 10 }}>
          <span style={{ fontSize: 12, fontWeight: 500 }}>
            {reviewSafe ? "Candidate records · Pilot view" : "Senior React Engineer · Remote / Global"}
          </span>
          <span className="tag" style={{ fontSize: 9 }}>
            {reviewSafe ? "Review records" : "128 in network"}
          </span>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {(reviewSafe ? ["Role profile", "Skills context", "Review state"] : ["React", "TypeScript", "Global pool"]).map((tag) => (
            <span className="tag" key={tag}>{tag}</span>
          ))}
        </div>
      </div>
      {shown.map((c) => (
        <div key={c.n} className="mockup" style={{
          padding: 10, display: "flex", alignItems: "center", gap: 12,
        }}>
          <div style={{
            width: 30, height: 30, borderRadius: 999,
            background: "var(--paper-3)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--fg-muted)",
          }}>{reviewSafe ? c.n.slice(-1) : c.n.split("-")[1].slice(0, 2)}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11.5, fontWeight: 500, color: "var(--fg)" }}>{c.n}</div>
            <div style={{ fontSize: 10, color: "var(--fg-subtle)" }}>{c.role}</div>
          </div>
          {reviewSafe ? (
            <span className="tag" style={{ fontSize: 9, whiteSpace: "nowrap" }}>{c.status}</span>
          ) : (
            <>
              <div style={{
                width: 50, height: 4, background: "var(--paper-3)",
                borderRadius: 999, overflow: "hidden",
              }}>
                <div style={{ width: `${c.match}%`, height: "100%", background: "var(--moss)" }} />
              </div>
              <span className="mono" style={{ fontSize: 10, color: "var(--fg-muted)" }}>{c.match}%</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

const H8_S07_VARIANT_ECOSYSTEMS = [
  {
    id: "customer-growth",
    tab: "Customer Growth",
    eyebrow: "CUSTOMER GROWTH",
    title: "Customer Growth",
    lead: "Customer conversations, content workflows, and human handover.",
    cards: [
      { name: "NEXT CX AI", status: "Available", description: "Guide customer conversations and hand over clear context when people need to step in.", image: "/assets/section-07-product-ecosystem/next-cx-ai-illustrative.png", imageAlt: "Illustrative NEXT CX AI interface", concept: "cx" },
      { name: "SmartPost AI", status: "Beta · Pilot available", description: "Plan, draft, and review content with human approval before publishing.", image: "/assets/section-07-product-ecosystem/smartpost-product-screen.png", imageAlt: "SmartPost AI product screen" },
    ],
  },
  {
    id: "workforce-growth",
    tab: "Workforce Growth",
    eyebrow: "WORKFORCE GROWTH",
    title: "Workforce Growth",
    lead: "Talent discovery, workforce operations, and team management.",
    cards: [
      { name: "Talent Cloud", status: "Beta · Pilot available", description: "Build a living profile that connects skills, projects, and global opportunities.", image: "/assets/section-07-product-ecosystem/talentcloud-product-screen.jpeg", imageAlt: "Talent Cloud product screen" },
      { name: "NEXT Workforce", status: "Beta · Pilot available", description: "Coordinate people and AI agents across teams, projects, and shared workspaces.", concept: "workforce" },
    ],
  },
];

function useH8S07ReducedMotion() {
  const [reduced, setReduced] = useState_Prod(false);
  useEffect_Prod(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReduced(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  return reduced;
}

function H8S07CustomerStage({ reducedMotion }) {
  return (
    <div className="h8-s07-stage h8-s07-customer-stage" role="img" aria-label="Customer Growth flow from SmartPost AI to NEXT CX AI">
      <img src="/assets/section-07-product-ecosystem/customer-growth-master-v1.png" alt="" />
      <div className="h8-s07-customer-flow" aria-hidden="true">
        <svg viewBox="0 0 258 550" preserveAspectRatio="none">
          <defs>
            <marker id="h8-s07-flow-arrow" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6 Z" /></marker>
            <path id="h8-s07-flow-path" d="M252 46 H187 C158 46 137 69 137 98 V424 C137 457 114 478 80 478 H8" />
          </defs>
          <use href="#h8-s07-flow-path" className="h8-s07-flow-line" markerEnd="url(#h8-s07-flow-arrow)" />
          {[116, 205, 294, 383].map((cy) => <circle key={cy} className="h8-s07-flow-node" cx="137" cy={cy} r="7" />)}
          <text x="156" y="120">ATTRACT</text><text x="156" y="209">UNDERSTAND</text><text x="156" y="298">RESPOND</text><text x="156" y="379">HUMAN</text><text x="156" y="395">HANDOVER</text>
          {reducedMotion ? <circle className="h8-s07-flow-traveller" cx="137" cy="294" r="6" /> : <circle className="h8-s07-flow-traveller" r="6"><animateMotion dur="8s" calcMode="spline" keyTimes="0;1" keySplines=".42 0 .58 1" repeatCount="indefinite"><mpath href="#h8-s07-flow-path" /></animateMotion></circle>}
        </svg>
      </div>
    </div>
  );
}

function H8S07WorkforceStage({ reducedMotion }) {
  const labels = [
    { className: "is-find", icon: "⌕", label: <>Find<br />Talent</> },
    { className: "is-workspace", icon: "▦", label: <>Virtual<br />Workspace</> },
    { className: "is-skills", icon: "✦", label: <>Grow<br />Skills</> },
    { className: "is-experience", icon: "✓", label: <>Grow<br />Experience</> },
  ];
  return (
    <div className="h8-s07-stage h8-s07-workforce-stage" role="img" aria-label="HR OS with four connected workforce capabilities">
      <img src="/assets/section-07-product-ecosystem/workforce-hr-os-base-v1.png" alt="" />
      <svg className="h8-s07-workforce-connectors" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        <defs>
          <path id="h8-s07-workforce-one" d="M50.2 57.7 C48 51 41 43 35 38" /><path id="h8-s07-workforce-two" d="M50.2 57.7 C54 51 62 43 68 38" />
          <path id="h8-s07-workforce-three" d="M50.2 57.7 C42 60 34 67 29 72" /><path id="h8-s07-workforce-four" d="M50.2 57.7 C58 60 65 67 68 72" />
        </defs>
        {["one", "two", "three", "four"].map((id) => <use key={id} href={`#h8-s07-workforce-${id}`} className="h8-s07-connector-line" />)}
      </svg>
      {labels.map((label) => <div className={`h8-s07-workforce-label ${label.className}`} key={label.className}><span>{label.icon}</span>{label.label}</div>)}
      <div className="h8-s07-workforce-core"><strong>HR OS</strong><small>The connected workforce layer</small></div>
    </div>
  );
}

function H8S07Concept({ type }) {
  return <div className={`h8-s07-concept is-${type}`} aria-hidden="true"><span className="h8-s07-concept-grid" /><span className="h8-s07-concept-line" /><i className="is-one" /><i className="is-two" /><i className="is-three" /></div>;
}

/* Each product used to have its own page. Until those exist again, the card
   opens the consultation with the product name so the interest is not lost. */
function H8S07ProductCard({ product }) {
  return (
    <a
      className="h8-s07-product-card"
      href={S.nextStep}
      onClick={openConsult({ source: "products", draft: `I'd like to know more about ${product.name}.` })}
    >
      <div className="h8-s07-card-media">
        {product.image ? <img src={product.image} alt={product.imageAlt} /> : <H8S07Concept type={product.concept} />}
        {product.concept ? <span className="h8-s07-concept-badge">Illustrative concept</span> : null}
      </div>
      <div className="h8-s07-card-copy"><h3>{product.name}</h3><span>{product.status}</span><p>{product.description}</p><b>Discuss {product.name} <i aria-hidden="true">→</i></b></div>
    </a>
  );
}

function H8S07ProductEcosystemVariant() {
  const [activeId, setActiveId] = useState_Prod(H8_S07_VARIANT_ECOSYSTEMS[0].id);
  const tabsRef = useRef_Prod([]);
  const reducedMotion = useH8S07ReducedMotion();
  const activeIndex = Math.max(0, H8_S07_VARIANT_ECOSYSTEMS.findIndex((item) => item.id === activeId));
  const active = H8_S07_VARIANT_ECOSYSTEMS[activeIndex];
  const choose = (index, focus) => {
    const nextIndex = (index + H8_S07_VARIANT_ECOSYSTEMS.length) % H8_S07_VARIANT_ECOSYSTEMS.length;
    setActiveId(H8_S07_VARIANT_ECOSYSTEMS[nextIndex].id);
    if (focus) tabsRef.current[nextIndex]?.focus();
  };
  const onKeyDown = (event) => {
    const keys = { ArrowRight: activeIndex + 1, ArrowDown: activeIndex + 1, ArrowLeft: activeIndex - 1, ArrowUp: activeIndex - 1, Home: 0, End: H8_S07_VARIANT_ECOSYSTEMS.length - 1 };
    if (!(event.key in keys)) return;
    event.preventDefault();
    choose(keys[event.key], true);
  };
  return (
    <section className="section-pad h8-s07-product-ecosystem" id="our-products">
      <div className="container h8-s07-shell">
        <div className="section-header h8-s07-header"><div className="eyebrow">PRODUCT ECOSYSTEM</div><h2>Products for customer and workforce growth.</h2><p className="lead">Explore two product ecosystems, each with a clear purpose and current availability.</p></div>
        <div className="h8-s07-tabs" role="tablist" aria-label="Product ecosystems" onKeyDown={onKeyDown}>
          {H8_S07_VARIANT_ECOSYSTEMS.map((item, index) => <button type="button" key={item.id} id={`h8-s07-${item.id}-tab`} role="tab" aria-selected={item.id === active.id} aria-controls={`h8-s07-${item.id}-panel`} tabIndex={item.id === active.id ? 0 : -1} ref={(node) => { tabsRef.current[index] = node; }} onClick={() => choose(index)} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); choose(index, true); } }}>{item.tab}</button>)}
        </div>
        <div id={`h8-s07-${active.id}-panel`} role="tabpanel" aria-labelledby={`h8-s07-${active.id}-tab`} className="h8-s07-panel">
          <div className="h8-s07-hero-grid"><div className="h8-s07-hero-copy"><p>{active.eyebrow}</p><h3>{active.title}</h3><span>{active.lead}</span></div>{active.id === "customer-growth" ? <H8S07CustomerStage reducedMotion={reducedMotion} /> : <H8S07WorkforceStage reducedMotion={reducedMotion} />}</div>
          <div className="h8-s07-card-grid">{active.cards.map((product) => <H8S07ProductCard key={product.name} product={product} />)}</div>
        </div>
      </div>
    </section>
  );
}

function H8S08MyanmarMarketSupport() {
  const sectionRef = useRef_Prod(null);
  const [hasEntered, setHasEntered] = useState_Prod(false);
  const reducedMotion = useH8S07ReducedMotion();

  useEffect_Prod(() => {
    const target = sectionRef.current;
    if (!target || hasEntered) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setHasEntered(true);
        observer.disconnect();
      }
    }, { threshold: 0.24 });
    observer.observe(target);
    return () => observer.disconnect();
  }, [hasEntered]);

  return (
    <section className="section-pad h8-s08-myanmar-market-support" id="myanmar-market-support" ref={sectionRef}>
      <div className="container h8-s08-shell">
        <div className="section-header h8-s08-header"><div className="eyebrow">MYANMAR MARKET SUPPORT</div><h2>Local context, clearer next steps.</h2><p className="lead">A compact support offer for teams deciding how to begin work in Myanmar.</p></div>
        <div className="h8-s08-card-grid">
          <article className="h8-s08-card h8-s08-support-card">
            <div className="h8-s08-kicker">WORKING IN MYANMAR</div>
            <h3>Planning work in Myanmar?</h3>
            <p>Use local context to make a practical business decision, then choose the right next step.</p>
            <a className="h8-s08-cta" href={S.nextStep} onClick={openConsult({ source: "myanmar-market-support" })}>Discuss Myanmar Market Support <span aria-hidden="true">→</span></a>
            <div className={`h8-s08-progress ${hasEntered ? "is-playing" : ""} ${reducedMotion ? "is-reduced" : ""}`} aria-label="Understand context, choose a first move, connect the right team">
              <div className="h8-s08-progress-track" aria-hidden="true"><span className="h8-s08-progress-line" /><i className="is-one" /><i className="is-two" /><i className="is-three" /><b /></div>
              <div className="h8-s08-progress-labels"><span>Understand context</span><span>Choose a first move</span><span>Connect the right team</span></div>
            </div>
          </article>
          <figure className="h8-s08-card h8-s08-map-card">
            <img src="/assets/section-08-myanmar-market-support/myanmar-context-map-v1.png" alt="Abstract layered visual inspired by Myanmar geography and local context." />
            <figcaption>Illustrative concept</figcaption>
          </figure>
        </div>
        <details className="h8-s08-scope"><summary>Engagement scope</summary><p>Every engagement is scoped and quoted individually. Support for registration, licensing, visa, regulatory, and government processes is agreed case by case; approval, visa, sales, and commercial outcomes cannot be guaranteed.</p></details>
      </div>
    </section>
  );
}

function H8S09HowWeStart() {
  const sectionRef = useRef_Prod(null);
  const [hasEntered, setHasEntered] = useState_Prod(false);
  const reducedMotion = useH8S07ReducedMotion();
  const steps = [
    ["Clarify the business question.", "Start with the decision, context, and outcome that matter most."],
    ["Agree the smallest useful scope.", "Choose the lightest practical way to learn what is worth doing next."],
    ["Set responsibility and the next decision.", "Make the people, review points, and decision boundary clear before work begins."],
    ["Test, build, or plan with an agreed quote.", "Move forward through assessment, a focused test, delivery, or further planning."],
  ];

  useEffect_Prod(() => {
    const target = sectionRef.current;
    if (!target || hasEntered) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setHasEntered(true);
        observer.disconnect();
      }
    }, { threshold: 0.22 });
    observer.observe(target);
    return () => observer.disconnect();
  }, [hasEntered]);

  const openNextAI = (event) => {
    event.preventDefault();
    try {
      window.dispatchEvent(new CustomEvent("nx:consult:open", {
        detail: { focusComposer: true, source: "home-h8-s09" },
      }));
    } catch (_) {}
  };

  return (
    <section className="section-pad h8-s09-how-we-start" id="how-we-start" ref={sectionRef}>
      <div className="container h8-s09-shell">
        <div className="h8-s09-heading">
          <div>
            <div className="eyebrow">HOW WE START</div>
            <h2>Start with a clear next step.</h2>
          </div>
          <p className="lead">Bring the question you need to decide. We clarify the smallest useful scope, agree who is responsible for what, and decide what to do next.</p>
        </div>
        <div className={`h8-s09-timeline ${hasEntered ? "is-playing" : ""} ${reducedMotion ? "is-reduced" : ""}`} aria-label="How we start">
          <div className="h8-s09-steps-shell">
            <span className="h8-s09-rail" aria-hidden="true"><i /></span>
            <span className="h8-s09-traveller" aria-hidden="true" />
            <div className="h8-s09-steps">
              {steps.map(([title, detail]) => <article className="h8-s09-step" key={title}><span className="h8-s09-node" aria-hidden="true" /><h3>{title}</h3><p>{detail}</p></article>)}
            </div>
          </div>
          <div className="h8-s09-actions">
            <a href={S.nextStep} onClick={openConsult({ source: "how-we-start" })}>Start a consultation <span aria-hidden="true">→</span></a>
            <button type="button" onClick={openNextAI}>Ask Next AI <span aria-hidden="true">→</span></button>
          </div>
          <p className="h8-s09-disclosure">Ask Next AI opens a guided on-site conversation. It does not submit an inquiry for you.</p>
        </div>
      </div>
    </section>
  );
}

function OurProducts() {
  return <><H8S07ProductEcosystemVariant /><H8S08MyanmarMarketSupport /><H8S09HowWeStart /></>;
}

export {
  OurProducts,
  SmartPostMockup as H8SmartPostMockup,
  TalentMockup as H8TalentMockup,
};
